// REDUX
import { useAppSelector } from "../../../../store/hooks";

// STYLES
import styles from "./BackHeader.module.scss";

// ICONS
import ArrowLeftIcon from "../../../../assets/icons/arrow-left.svg?react";

interface Props {
  onGoBack?: () => void;
  showButton?: boolean;
  companyName: string;
}

export const BackHeader = ({
  onGoBack,
  showButton = true,
  companyName,
}: Props) => {
  const { headerContainer, backButton, titleText, arrowIcon } = styles;
  const { step } = useAppSelector((state) => state.crypto);

  const getTitle = () => {
    switch (step) {
      case "ACCOUNTS":
        return `Ir a ${companyName}`;
      case "CONFIRM":
        return "Preconfirmación de operación";
      case "DETAILS":
      case "STATUS":
      case "REDIRECT":
        return "";
    }
  };

  return (
    <div className={headerContainer}>
      {showButton && (
        <div
          className={backButton}
          onClick={onGoBack}
          aria-label="Volver atrás"
        >
          <ArrowLeftIcon className={arrowIcon} />
        </div>
      )}
      <p className={`${titleText}`}>{getTitle()}</p>
    </div>
  );
};
